<template>
  <div class="event-card" :style="style">
    <div
      class="event-card__date"
      :class="{ 'event-card__date--multiple': end }"
    >
      <div class="event-card__date--wrapper">
        <div class="event-card__date--month">{{ start.monthShort }}</div>
        <div class="event-card__date--day" :style="dateStyle">
          <span class="event-card__date--start">{{ start.day }}</span>
          <span class="event-card__date--separator">-</span>
          <span class="event-card__date--end" v-if="end">{{ end.day }}</span>
        </div>
      </div>
    </div>
    <div class="event-card__subject">
      <span v-for="category in formattedCategory" :key="category" :style="{color: categoryColorMap[category.toLowerCase()]}">
        {{category}}
      </span>
    </div>
    <div class="event-card__title" :style="titleStyle">{{ title }}</div>
    <div class="event-card__type-wrapper">
      <div class="event-card__attendance-separator">•</div>
      <div class="event-card__attendance-type">{{ formattedType }}</div>
    </div>
    <div class="event-card__attendance">
      <div class="event-card__local" v-if="location">{{ location }}</div>
    </div>
    <div class="event-card__cta">
      <c-button class="event-card__btn" target="_blank" :bg-color="btnBg" :color="btnColor" :radius="4" :href="link">
        {{buttonLabel}}
      </c-button>
    </div>
  </div>
</template>

<script>
import utils from '../../../utils/utils'

const months = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
]

const processISODate = (str) => {
  const dateArray = str.split('-')
  const data = {
    year: dateArray[0],
    month: dateArray[1],
    day: dateArray[2]
  }
  data.monthShort = months[+data.month - 1]
  return data
}

export default {
  name: 'eventCard',
  props: {
    category: { type: [String, Array] },
    title: String,
    location: String,
    type: String,
    link: String,
    buttonLabel: {
      type: String,
      default: 'Learn more'
    },
    startDate: { type: String, required: true },
    endDate: String,
    dateColor: { type: String },
    titleColor: { type: String },
    btnBg: { type: String, default: '' },
    btnColor: { type: String },
    categoryColorMap: { type: Object, default: () => ({}) },
    bgColor: { type: String },
  },
  computed: {
    start() {
      return processISODate(this.startDate)
    },
    end() {
      return this.endDate ? processISODate(this.endDate) : null
    },
    formattedType() {
      if (this.type === 'inperson') return 'In-Person'
      if (this.type === 'webinar') return 'Webinar'
      return this.type
    },
    formattedCategory() {
      if (Array.isArray(this.category)) return this.category
      return [this.category]
    },
    style() {
      return {
        backgroundColor: this.bgColor
      }
    },
    titleStyle() {
      return {
        color: this.titleColor
      }
    },
    dateStyle() {
      return {
        color: this.dateColor
      }
    },
    categoryStyle() {
      return {
        color: this.categoryColor
      }
    }
  },
  mounted() {
    if (utils.isMobile()) return
    utils.setAllElSameHeigts('event-card__attendance')
    utils.setAllElSameHeigts('event-card__subject')
  }
}
</script>
